import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import React, { useRef, useState } from 'react';
import { postRopa } from '../../services/apis';

export const FormCrearRopa = ({ open, setOpen, setRopa }) => {
    const [color, setColor] = useState('#000000');
    const colorInputRef = useRef(null);
    const [nuevaRopa, setNuevaRopa] = useState({
        nombre: '',
        color: color
    });

    const handleColorChange = (event) => {
        setColor(event.target.value);
        setNuevaRopa({ ...nuevaRopa, color: event.target.value });
    };

    const crearRopa = async (ropaNueva) => {
        try {
            const response = await postRopa(ropaNueva);

            if (response.success) {
                setRopa(response.data);
                setOpen(false);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle id="alert-dialog-title">
                Afegir roba
            </DialogTitle>
            <DialogContent>
                <Box className="clothes-form">
                    <TextField
                        variant="outlined"
                        name="nombre"
                        label="Nom"
                        fullWidth
                        value={nuevaRopa.nombre}
                        onChange={(event) => setNuevaRopa({ ...nuevaRopa, nombre: event.target.value })}
                    />
                    <Box className="clothes-form-color">
                        <Box className="clothes-form-color-copy">
                            <Typography className="clothes-form-label">
                                Color
                            </Typography>
                            <Typography className="clothes-form-code">
                                {color}
                            </Typography>
                        </Box>
                        <input
                            type="color"
                            ref={colorInputRef}
                            value={color}
                            onChange={handleColorChange}
                            id="primary_color"
                        />
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions className="clothes-dialog-actions">
                <Button onClick={() => setOpen(false)}>Cancel·lar</Button>
                <Button onClick={() => crearRopa(nuevaRopa)} variant="contained" autoFocus>
                    Afegir
                </Button>
            </DialogActions>
        </Dialog>
    );
};
